/* TPW — Cart drawer "Pairs well with" upsell engine.
   - Maintains a deep POOL of recommendations (Shopify complementary + related,
     across all cart items) so it never runs out.
   - Always shows ONE pick that is NOT already in the cart; when one is added (or
     already in the cart) it advances to the next, and keeps going.
   - Adds are OPTIMISTIC: the row advances to the next pick instantly on tap while
     the real add happens in the background via the drawer's renderContents() path.
   - Re-runs after every drawer render via a debounced MutationObserver. */
(function () {
  "use strict";
  if (window.__tpwCartUpsell) return;
  window.__tpwCartUpsell = true;

  var SECTION = "cart-recommendations";
  var recCache = {};        // "pid:intent" -> [cards]
  var pool = [];            // ordered candidate cards (deduped by pid), persists
  var poolSeen = {};        // pid -> true (in pool already)
  var optimistic = {};      // pid -> true (tapped Add, not yet reconciled)
  var seededFor = {};       // pid -> true (already requested recs for this seed)
  var lastCart = null;

  function freeThreshold() {
    var el = document.querySelector(".cart-shipping[data-min-spend]");
    var v = el && parseFloat(el.getAttribute("data-min-spend"));
    return v && v > 0 ? Math.round(v) : 15000;
  }
  function money(c) { return "$" + (c / 100).toFixed(2); }
  function drawer() { return document.querySelector("cart-drawer"); }
  function reduced() { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function fetchRecs(pid, intent) {
    var key = pid + ":" + intent;
    if (recCache[key]) return Promise.resolve(recCache[key]);
    var url = "/recommendations/products?section_id=" + SECTION +
      "&product_id=" + pid + "&intent=" + intent + "&limit=10";
    return fetch(url, { headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var cards = [].map.call(doc.querySelectorAll(".tpw-up-card"), function (el) {
          return {
            pid: el.getAttribute("data-pid"),
            variant: el.getAttribute("data-variant"),
            available: el.getAttribute("data-available") === "1",
            price: parseInt(el.getAttribute("data-price"), 10) || 0,
            title: el.getAttribute("data-title") || "",
            url: el.getAttribute("data-url") || "#",
            img: el.getAttribute("data-img") || ""
          };
        });
        recCache[key] = cards;
        return cards;
      })
      .catch(function () { return []; });
  }

  function addCards(cards) {
    cards.forEach(function (c) {
      if (c.available && c.pid && !poolSeen[c.pid]) { poolSeen[c.pid] = true; pool.push(c); }
    });
  }

  // Fetch complementary + related for every cart item (once per seed) and merge
  // into the pool, so there's always a deep, fresh queue to advance through.
  function topUp(cart) {
    var seeds = (cart.items || []).map(function (i) { return i.product_id; })
      .filter(function (p) { return !seededFor[p]; });
    if (!seeds.length) return Promise.resolve();
    seeds.forEach(function (p) { seededFor[p] = true; });
    var jobs = [];
    seeds.forEach(function (p) {
      jobs.push(fetchRecs(p, "complementary").then(addCards));
      jobs.push(fetchRecs(p, "related").then(addCards));
    });
    return Promise.all(jobs).catch(function () {});
  }

  function inCartMap(cart) {
    var m = {};
    (cart && cart.items || []).forEach(function (i) { m[i.product_id] = true; });
    return m;
  }
  function available(cart) {
    var ic = inCartMap(cart);
    return pool.filter(function (c) { return c.available && !ic[c.pid] && !optimistic[c.pid]; });
  }
  // pick: prefer the cheapest item that crosses the free-delivery line (gap-closer),
  // otherwise the next one in relevance order.
  function choose(cart, list) {
    if (!list.length) return null;
    var gap = freeThreshold() - (cart ? cart.total_price : 0);
    if (gap > 0) {
      var cr = list.filter(function (c) { return c.price >= gap; })
        .sort(function (a, b) { return a.price - b.price; });
      if (cr.length) return { pick: cr[0], crosses: true };
    }
    return { pick: list[0], crosses: false };
  }

  // P5 "Beam placeholder": a row-shaped skeleton shown while the FIRST recs are
  // fetched on a cold drawer open (the pool usually pre-warms, so this rarely
  // shows). renderUpsell() replaces it with the real pick, or hides the wrap if
  // there are no recs. Mirrors the real row shape; the shared Beam traces the base.
  var SKEL_HTML =
    '<span class="tpw-up-img tpw-up-skel__img"></span>' +
    '<span class="tpw-up-m">' +
      '<span class="tpw-up-skel__line tpw-up-skel__line--n"></span>' +
      '<span class="tpw-up-skel__line tpw-up-skel__line--p"></span>' +
    '</span>' +
    '<span class="tpw-up-skel__btn"></span>' +
    '<span class="tpwl-beambar is-on" aria-hidden="true"></span>';
  function showSkel() {
    var wrap = document.getElementById("tpw-upsell");
    var row = document.getElementById("tpw-up-row");
    if (!wrap || !row) return;
    // only on a cold open — never replace a real pick that's already showing
    if (row.querySelector(".tpw-up-add")) return;
    write(function () {
      wrap.hidden = false;
      row.classList.add("is-skel");
      row.innerHTML = SKEL_HTML;
    });
  }

  function renderUpsell(cart) {
    var wrap = document.getElementById("tpw-upsell");
    var row = document.getElementById("tpw-up-row");
    if (!wrap || !row) return;
    row.classList.remove("is-skel");
    var chosen = choose(cart, available(cart));
    if (!chosen) { wrap.hidden = true; return; }
    var p = chosen.pick;
    wrap.hidden = false;
    var thumb = p.img
      ? '<span class="tpw-up-img"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="46" height="46" loading="lazy" decoding="async"></span>'
      : '<span class="tpw-up-img tpw-up-img--ph"></span>';
    row.innerHTML = thumb +
      '<span class="tpw-up-m">' +
        '<a class="tpw-up-n" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="tpw-up-p">' + money(p.price) +
          (chosen.crosses ? '<span class="tpw-up-tag">unlocks free delivery</span>' : '') +
        '</span>' +
      '</span>' +
      '<button type="button" class="tpw-up-add" data-variant="' + esc(p.variant) + '" data-pid="' + esc(p.pid) + '" aria-label="Add ' + esc(p.title) + ' to cart">Add</button>';
  }

  /* ---- background add via the drawer's own renderContents path ---- */
  function addVariant(variantId) {
    var d = drawer();
    if (!d || typeof d.getSectionsToRender !== "function") return Promise.resolve(false);
    var ids = d.getSectionsToRender().map(function (s) { return s.id; }).join(",");
    var body = JSON.stringify({ id: Number(variantId), quantity: 1, sections: ids, sections_url: window.location.pathname });
    // claim the add so the global interceptor skips its redundant re-fetch + open
    window.__tpwCartHandled = Date.now();
    window.__tpwCartOpenGuard = Date.now();
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) return false; // sold out / error
        window.__tpwCartHandled = Date.now();
        if (typeof d.renderContents === "function" && res.sections) {
          d.renderContents(res);
          // recompute dispatch/collect text right away (renderContents recreated the
          // nodes); via write() so the mutation can't re-trigger the observer.
          if (typeof window.tpwDispatchApply === "function") write(function () { window.tpwDispatchApply(); });
        } else {
          schedule();
        }
        return true;
      })
      .catch(function () { return false; });
  }

  function flyToCart(fromEl) {
    if (reduced() || !fromEl) return;
    var count = document.querySelector(".cart-drawer__header-count");
    if (!count) return;
    var img = fromEl.querySelector("img") || fromEl;
    var r = img.getBoundingClientRect(), t = count.getBoundingClientRect();
    if (!r.width) return;
    var g = document.createElement("div");
    g.className = "tpw-fly";
    g.style.left = r.left + "px"; g.style.top = r.top + "px";
    g.style.width = r.width + "px"; g.style.height = r.height + "px";
    if (img.tagName === "IMG") g.style.backgroundImage = "url(" + img.src + ")";
    document.body.appendChild(g);
    g.animate([
      { transform: "translate(0,0) scale(1)", opacity: 1 },
      { transform: "translate(" + (t.left - r.left) + "px," + (t.top - r.top) + "px) scale(.3)", opacity: 0 }
    ], { duration: 480, easing: "cubic-bezier(.22,.61,.36,1)" }).onfinish = function () { g.remove(); };
    count.classList.add("tpw-bump");
    setTimeout(function () { count.classList.remove("tpw-bump"); }, 220);
  }

  /* ---- render scheduling (observer-safe) ---- */
  var busy = false, t, observer = null;
  function write(fn) {
    if (observer) observer.disconnect();
    try { fn(); } finally {
      if (observer) { requestAnimationFrame(reconnect); setTimeout(reconnect, 250); }
    }
  }
  function refresh() {
    var d = drawer();
    if (!d) return;
    if (d.classList.contains("is-empty")) {
      write(function () { var w = document.getElementById("tpw-upsell"); if (w) w.hidden = true; });
      return;
    }
    if (busy) return;
    busy = true;
    showSkel(); // P5: placeholder during the cold-open fetch (no-op if a pick is already shown)
    getCart().then(function (cart) {
      lastCart = cart;
      // once a tapped item is really in the cart, drop its optimistic exclusion
      // (so it can be suggested again later if the shopper removes it).
      var ic = inCartMap(cart);
      Object.keys(optimistic).forEach(function (pid) { if (ic[pid]) delete optimistic[pid]; });
      return topUp(cart).then(function () {
        write(function () {
          renderUpsell(cart);
          if (typeof window.tpwDispatchApply === "function") window.tpwDispatchApply();
        });
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* ---- click: OPTIMISTIC instant advance + background add ---- */
  document.addEventListener("click", function (e) {
    var add = e.target.closest && e.target.closest(".tpw-up-add");
    if (!add || add.tagName === "A") return;
    e.preventDefault();
    var variant = add.getAttribute("data-variant");
    var pid = add.getAttribute("data-pid");
    if (!variant) return;
    var row = add.closest(".tpw-up-row");
    var thumb = row && row.querySelector(".tpw-up-img");
    // 1) instantly advance to the next pick (exclude this one)
    if (pid) optimistic[pid] = true;
    flyToCart(thumb);
    write(function () { renderUpsell(lastCart); });
    // 2) add in the background; on failure, un-exclude and restore
    addVariant(variant).then(function (ok) {
      if (!ok && pid) { delete optimistic[pid]; write(function () { renderUpsell(lastCart); }); }
    });
  });

  /* ---- hook + prewarm ---- */
  function schedule() {
    // Update the dispatch/collect line IMMEDIATELY on any drawer render so it never
    // flashes the server fallback text. MUST go through write() (which disconnects
    // the observer) or this mutation would re-trigger the observer -> infinite loop.
    if (typeof window.tpwDispatchApply === "function") write(function () { window.tpwDispatchApply(); });
    clearTimeout(t); t = setTimeout(refresh, 80);
  }
  function reconnect() {
    var d = drawer();
    if (d && observer) {
      observer.disconnect();
      observer.observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
    }
  }
  // Ignore mutations that are only our own dispatch/collect text updates (incl. the
  // shared snippet's per-minute tick) so they don't churn /cart.js fetches or refreshes.
  function onMutations(muts) {
    for (var i = 0; i < muts.length; i++) {
      var tg = muts[i].target;
      var el = tg && tg.nodeType === 1 ? tg : (tg && tg.parentNode);
      if (!(el && el.closest && el.closest("[data-tpw-dispatch],[data-tpw-collect]"))) { schedule(); return; }
    }
  }
  function observe() {
    var d = drawer();
    if (!d) { setTimeout(observe, 300); return; }
    observer = new MutationObserver(onMutations);
    reconnect();
    schedule();
  }
  // warm the pool on idle so the first pick is instant on open
  function prewarm() {
    var d = drawer();
    if (!d || d.classList.contains("is-empty")) return;
    getCart().then(function (cart) { lastCart = cart; return topUp(cart); })
      .then(function () { write(function () { renderUpsell(lastCart); }); })
      .catch(function () {});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", observe);
  else observe();
  if ("requestIdleCallback" in window) requestIdleCallback(prewarm, { timeout: 2000 });
  else setTimeout(prewarm, 800);
})();
